<template lang="pug">
#home
  vheader
  mobile-nav
  .entry
    .cover
      .container
        h1 关于我们
    .container.min
      .about
        p 「前沿社」是由极客公园发起创立的企业家社群，通过「近场研究FIELD STUDY」、「前沿工作坊FRONTIER WORKSHOP」、「超频之旅OVERCLOCKING TRIP」三大板块，帮助企业家把握技术潮流、连接产业前沿及保持创新思维，以最有效率的方式，让最优秀的企业家与全球顶尖科学家、科技研究者一起迭代进步。

  footer-user
  vfooter
</template>

<script>
import Vheader from '../components/Vheader.vue'
import MobileNav from '../components/mobile/Nav.vue'
import FooterUser from '../components/FooterUser.vue'
import Vfooter from '../components/Vfooter.vue'

export default {
  data() {
    return {
      link: 'http://cn.mikecrm.com/bpvLg71'
    }
  },
  components: {
    Vheader,
    Vfooter,
    FooterUser,
    MobileNav
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'
.about
  line-height 1.8
  font-size 14px
  padding-top 1em
  p
    margin 1em
</style>



// WEBPACK FOOTER //
// About.vue?5ce1cce5